StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.FieldSelectionHandler extends StepHandler

    inputSel: 'button.spp-checkbox'

    addValidationRules: () =>
        @validator.registerRule
            selector: '.validate-checkbox'
            text: 'Please select one or more fields'
            func: (elem) =>
                return (!!@getInputEl().filter('.active').length)

        $('.validationContainer').undelegate '.validate-checkbox', 'change'


    getFieldAspect: (fieldID, aspectID) =>
        # we only return a boolean, not a result object
        return @getInputEl(field: fieldID).is(':enabled.active')

    setFieldAspect: (fieldAspect) =>
        input = @getInputEl
            field: fieldAspect.id

        if fieldAspect.selected and input.is(':enabled')
            input.addClass('active')
        else
            input.removeClass('active')


    afterLoadLayout: (sel, data) =>
        super(sel, data)

        num_fields = @taffyObjects.fields(disabled: '!is': true).count()
        @max_fields = if num_fields < 50 then num_fields else 50

        @layoutSelector.find('.fields-link').on 'click', () ->
            $('#nav_primary_links a').eq(0).trigger('click')

        step = this
        @getInputEl().on 'click', (e) ->
            el = $(this)

            if el.is(':not(.active)') and step._numSelectedFields() >= step.max_fields
                # if this would put us over 50 fields, don't do let it be selected
                e.stopImmediatePropagation()
                step.msg.message_writer 'error', 'You may not select more than 50 fields at once.'
                return

            step.msg.message_writer('clear')

            # This is to make sure that we don't fire the change event or call
            # _updateSelectAllButton after the click event handlers finish.
            # The button's "active" class will not be updated otherwise.

            # Basically this is because Bootstrap uses the .delegate method to
            # attach the click event handler that updates the "active" class.
            # With jQuery, any event handlers attached with .delegate are
            # called after those attached with .on, .bind, or .click.
            setTimeout () ->
                el.change()
                step._updateSelectAllButton()

        # Select All button interaction
        selectAll = $(@parent.layoutSelector).find('#select_all_button')
        selectAll.on 'click', () =>
            if selectAll.hasClass('active')
                @getInputEl().filter('.active').click()
            else
                # only select up to the first 50 fields, not necessarily all
                @taffyObjects.fields(disabled: '!is': true).limit(@max_fields).each (field) =>
                    el = @getInputEl(field: field.id)
                    if not el.is('.active')
                        el.addClass('active').change()

                # deselect the rest
                @taffyObjects.fields(disabled: '!is': true).start(@max_fields + 1).each (field) =>
                    el = @getInputEl(field: field.id)
                    if el.is('.active')
                        el.removeClass('active').change()

            @_updateSelectAllButton()

        # initialize the button
        @_updateSelectAllButton()

        # we don't want to enable the Next button if there are no fields
        if @taffyObjects.fields().get().length is 0
            $(@parent.layoutSelector).find('#next_button').prop('disabled', true)

    _updateSelectAllButton: () =>
        selectAll = $(@parent.layoutSelector).find('#select_all_button')

        if @_numSelectedFields() >= @max_fields
            selectAll.text('Deselect All').addClass('active')
        else
            selectAll.text('Select All').removeClass('active')

    _numSelectedFields: () =>
        return @getInputEl().filter('.active').length
